var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBackwardCircleOutline = function SvgArrowBackwardCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.3936,
    r: 18,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 31.3936L16 24.3936L23 17.3936",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.3936C32.5523 25.3936 33 24.9458 33 24.3936C33 23.8413 32.5523 23.3936 32 23.3936V25.3936ZM32 23.3936H16V25.3936H32V23.3936Z",
    fill: "white"
  })));
};
export { SvgArrowBackwardCircleOutline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNC4zOTM2IiByPSIxOCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yMyAzMS4zOTM2TDE2IDI0LjM5MzZMMjMgMTcuMzkzNiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMyIDI1LjM5MzZDMzIuNTUyMyAyNS4zOTM2IDMzIDI0Ljk0NTggMzMgMjQuMzkzNkMzMyAyMy44NDEzIDMyLjU1MjMgMjMuMzkzNiAzMiAyMy4zOTM2VjI1LjM5MzZaTTMyIDIzLjM5MzZIMTZWMjUuMzkzNkgzMlYyMy4zOTM2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";